module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/fahrenheit-053a095664c2590e2136a40ceac1e360.svg";